import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import Tooltip from '@Components/Tooltip';
import HoverTooltip from '@Components/HoverTooltip';

export default class SubstanceMetaItemComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    Tooltip.rebuild();
  }

  render() {
    const { tooltip, content, link } = this.props;
    return (
      <HoverTooltip
        className="substance__meta__item"
        tag="span"
        theme="simple"
        id={Tooltip.TooltipConstants.ids.GlobalHover}
        tooltip={tooltip}>
        <span className="substance__meta__item__content">
          {link && link.sourceUrl ? (
            <InnerHTML tag="a" href={link.sourceUrl} target="_blank" html={content} />
          ) : (
            <InnerHTML tag="span" html={content} />
          )}
        </span>
      </HoverTooltip>
    );
  }
}

SubstanceMetaItemComponent.propTypes = {
  content: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  link: PropTypes.object,
};
